import { Button, Col, Form, Row} from "react-bootstrap"
import { useTranslation } from "react-i18next"
import UnitMeasures from "../../components/UnitMeasures"

export default function ParameterForm({state, handleInputChange, handleSelectChange, submit, isAddingOrEditing, isRegistering, handleDeleteParameters, businesses}) {
    const { t } = useTranslation()
    return (
        <Form  onSubmit={submit} className="px-4 formulario">
            <Row>
                <Col className="my-2">
                    <Form.Label>{t('admin.parameters.name')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='teext'
                        name='name'
                        value={state.name ||  ''}
                        onChange={handleInputChange}
                        required
                    />
                </Col>
                <Col className="my-2">
                    <Form.Label>{t('admin.parameters.minValue')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='number'
                        step="any"
                        name='minValue'
                        value={state.minValue || 0}
                        onChange={handleInputChange}
                        onWheel={(e) => e.target.blur()}
                        required
                    />
                </Col>
                <Col className="my-2">
                    <Form.Label>{t('admin.parameters.maxValue')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='number'
                        step="any"
                        name='maxValue'
                        value={state.maxValue || 0}
                        onChange={handleInputChange}
                        onWheel={(e) => e.target.blur()}
                        required
                    />
                </Col>
                <Col className="my-2">
                    <Form.Label>{t('admin.parameters.unit')}</Form.Label>
                    <UnitMeasures
                        onChange={(selected) => handleSelectChange({ target: { name: 'unitMeasure', value: selected?.value } })}
                        value={state.unitMeasure ? { value: state.unitMeasure, label: t(state.unitMeasure) } : null}
                    />
                </Col>
            </Row>
            <Row>
                <Col xs={12} lg={6} className="my-2 ms-auto">
                    <Button variant='primary' type="submit" className="w-100 my-2">
                    {isRegistering
                        ?
                            <>
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </>
                        :
                            isAddingOrEditing === 'editing'
                            ?
                                <>{t('global.edit')}</>
                            :
                                <>{t('global.register')}</>
                    }
                    </Button>
                    {isAddingOrEditing === 'editing' && (
                        <Button variant="fourth" className="w-100 my-2 cursor" onClick={(e) => handleDeleteParameters(e, state?._id)}>
                            {t('global.delete')}
                        </Button>
                    )}

                </Col>
            </Row>
        </Form>
    )
}